/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ImageGenerationUpdatedImageStatus } from "./ImageGenerationUpdatedImageStatus";

export interface ImageGenerationUpdatedImage {
  image_id: string;
  status: ImageGenerationUpdatedImageStatus;
  url?: string | null;
}
